import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, RadioButtonModule,
  DataTableModule, InputMaskModule
} from 'primeng/primeng';
import { Ng2BRPipesModule } from 'ng2-brpipes';
import { SispacSharedModule } from '../shared/sispac-shared.module';
import { FinanceiroRouting } from './financeiro.routing';
import { GerenciarPrestacaoContasComponent } from './gerenciar-prestacao-contas/gerenciar-prestacao-contas.component';
import { FinanceiroService } from './financeiro.service';
import { CadastrarLancamentoFormComponent } from './cadastrar-lancamento-form/cadastrar-lancamento-form.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { EnviarPrestacaoAnaliseComponent } from './enviar-prestacao-analise/enviar-prestacao-analise.component';
import { VisualizarPrestacaoContasComponent } from './visualizar-prestacao-contas/visualizar-prestacao-contas.component';
import { CompararDespesasComponent } from './comparar-despesas/comparar-despesas.component';
import { VisualizarGastosTipoFornecedorComponent } from './visualizar-gastos-tipo-fornecedor/visualizar-gastos-tipo-fornecedor.component';
import { ManterContaComponent } from './manter-conta/manter-conta.component';
import { ManterTipoDespesaComponent } from './manter-tipo-despesa/manter-tipo-despesa.component';
import { GerenciarValorDespesaFornecedorComponent } from './gerenciar-valor-despesa-fornecedor/gerenciar-valor-despesa-fornecedor.component';
import { CadastarValorDespesaFornecedorFormComponent } from './cadastar-valor-despesa-fornecedor-form/cadastar-valor-despesa-fornecedor-form.component';
import { EntradaTransferenciaFormComponent } from './entrada-transferencia-form/entrada-transferencia-form.component';
import { SaidaFormComponent } from './saida-form/saida-form.component';
import { FornecedorService } from '../fornecedor/fornecedor.service';


@NgModule({
  imports: [
    // CommonModule,
    BrowserModule,
    FormsModule, ReactiveFormsModule,
    ConfirmDialogModule, CalendarModule, FileUploadModule, DialogModule, RadioButtonModule, DataTableModule, InputMaskModule,

    FinanceiroRouting,

    Ng2BRPipesModule,
    CurrencyMaskModule,
    SispacSharedModule,
  ],
  providers: [FinanceiroService, FornecedorService],
  declarations: [
    GerenciarPrestacaoContasComponent,
    CadastrarLancamentoFormComponent,
    EnviarPrestacaoAnaliseComponent,
    VisualizarPrestacaoContasComponent,
    CompararDespesasComponent,
    VisualizarGastosTipoFornecedorComponent,
    ManterContaComponent,
    ManterTipoDespesaComponent,
    GerenciarValorDespesaFornecedorComponent,
    CadastarValorDespesaFornecedorFormComponent,
    EntradaTransferenciaFormComponent,
    SaidaFormComponent,
  ]
})
export class FinanceiroModule { }



// WEBPACK FOOTER //
// ./src/app/components/financeiro/financeiro.module.ts